var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("LETTER OF AUTHORIZATION (LOA)")]),_c('h4',[_vm._v("Letter of authorization duly issued by HMI to, and signed by, the Member which shall serve as the authority of the latter to avail of the medical service.")])])
}]

export { render, staticRenderFns }